export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "v3.416/checksum.worker.bundle.worker.js");
}
